export default function How(){
    return (
        <>
        <section className="py-5 sm:py-12 relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                {/* Main Title */}
                <div className="text-center mb-12">
                    <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                        Hoe Werkt Het?
                    </h1>
                </div>

                {/* Steps Container */}
                <div className="max-w-4xl mx-auto">
                    {/* Step 1 */}
                    <div className="flex flex-col sm:flex-row items-start mb-8 sm:mb-12 relative">
                        {/* Step Number Circle */}
                        <div className="flex-shrink-0 relative mb-4 sm:mb-0">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#0a1a5f] to-[#002f9c] rounded-full flex items-center justify-center shadow-2xl">
                                <span className="text-lg sm:text-2xl font-bold text-white">1</span>
                            </div>
                            {/* Connecting Line */}
                            <div className="absolute top-12 sm:top-16 left-1/2 transform -translate-x-1/2 w-0.5 h-8 sm:h-16 bg-gradient-to-b from-[#0a1a5f] to-transparent"></div>
                        </div>
                        
                        {/* Step Content */}
                        <div className="sm:ml-8 flex-1 w-full">
                            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                                <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-2 sm:mb-3 flex items-center">
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#0a1a5f] mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                                    </svg>
                                    Plaats je Bestelling
                                </h3>
                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                                    Kies je gewenste IPTV-abonnement uit onze premium pakketten.
                                    Snel en veilig proces met meerdere betaalopties.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="flex flex-col sm:flex-row items-start mb-8 sm:mb-12 relative">
                        {/* Step Number Circle */}
                        <div className="flex-shrink-0 relative mb-4 sm:mb-0">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#002f9c] to-[#0d47ff] rounded-full flex items-center justify-center shadow-2xl">
                                <span className="text-lg sm:text-2xl font-bold text-white">2</span>
                            </div>
                            {/* Connecting Line */}
                            <div className="absolute top-12 sm:top-16 left-1/2 transform -translate-x-1/2 w-0.5 h-8 sm:h-16 bg-gradient-to-b from-[#0d47ff] to-transparent"></div>
                        </div>
                        
                        {/* Step Content */}
                        <div className="sm:ml-8 flex-1 w-full">
                            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                                <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-2 sm:mb-3 flex items-center">
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#002f9c] mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                                    </svg>
                                    Ontvang je Account
                                </h3>
                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                                    Na betaling ontvang je binnen 10 minuten je inloggegevens
                                    en installatiehandleiding per e-mail. Directe activering!
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="flex flex-col sm:flex-row items-start mb-8 sm:mb-16 relative">
                        {/* Step Number Circle */}
                        <div className="flex-shrink-0 relative mb-4 sm:mb-0">
                            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-[#0d47ff] to-[#1d4ed8] rounded-full flex items-center justify-center shadow-2xl">
                                <span className="text-lg sm:text-2xl font-bold text-white">3</span>
                            </div>
                            {/* Connecting Line */}
                            <div className="absolute md:hidden top-12 sm:top-16 left-1/2 transform -translate-x-1/2 w-0.5 h-8 sm:h-16 bg-gradient-to-b from-[#0d47ff] to-transparent"></div>
                        </div>
                        
                        {/* Step Content */}
                        <div className="sm:ml-8 flex-1 w-full">
                            <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                                <h3 className="text-lg sm:text-xl font-bold text-blue-900 mb-2 sm:mb-3 flex items-center">
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-[#0d47ff] mr-2 sm:mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"/>
                                    </svg>
                                    Geniet van je IPTV!
                                </h3>
                                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                                    Begin direct met het bekijken van alle kanalen, films en series!
                                    4K/Full HD kwaliteit op al je apparaten.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Call to Action */}
                <div className="text-center">
                    <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-xl border border-gray-100 max-w-2xl mx-auto">
                        <h2 className="text-lg sm:text-xl font-bold text-blue-900 mb-3 sm:mb-4">
                            Kies de #1 IPTV-Provider in Nederland, België en Europa
                        </h2>
                        <button
                            onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                            className="bg-gradient-to-r from-[#0a1a5f] via-[#002f9c] to-[#0d47ff] hover:from-[#002f9c] hover:to-[#0d47ff] text-white px-6 sm:px-8 py-2 sm:py-3 rounded-xl font-bold text-sm sm:text-lg transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105"
                        >
                            Nu Beginnen
                        </button>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}